/**
 * Phones open the drawer's dialogs (Rename folder, Announcements, Refer us)
 * from an action sheet rather than a Radix trigger, so Radix has nothing to
 * hand focus back to when they close and VoiceOver and keyboards land on
 * <body>. These put it back on what opened them.
 */

/** Focuses the opener, or the More tab when the opener has gone (after a rotation). */
export const focusOpener = (opener: HTMLElement | null | undefined) => {
	const target =
		opener?.isConnected && opener !== document.body
			? opener
			: document.querySelector<HTMLElement>('[data-mobile-tab="more"]');
	target?.focus({ preventScroll: true });
	return !!target;
};

/**
 * For a dialog whose content isn't ours to give an onCloseAutoFocus: waits
 * for it to finish closing, then focuses the opener if focus fell to <body>.
 * Leaves focus alone if the person has already moved it somewhere else.
 */
export const returnFocusAfterClose = (opener: HTMLElement | null | undefined) => {
	const started = performance.now();
	let frame = 0;
	const check = () => {
		const active = document.activeElement;
		if (!active || active === document.body) {
			focusOpener(opener);
			return;
		}
		// Still inside the dialog while it animates out.
		const closing = active.closest('[role="dialog"][data-state="closed"]');
		if (closing && performance.now() - started < 1500) frame = requestAnimationFrame(check);
	};
	frame = requestAnimationFrame(check);
	return () => cancelAnimationFrame(frame);
};
